// extracted by mini-css-extract-plugin
export default {"order_modal":"order-modal_order_modal__5WMjl","order_modal_text_case_lower":"order-modal_order_modal_text_case_lower__XqJj4"};